import React from "react";
import ReactDOM from "react-dom";
import { Box, Paper, Typography, Button, Stack } from "@mui/material";
import HourglassEmptyRoundedIcon from "@mui/icons-material/HourglassEmptyRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const PendingSpopup = ({ setPendingPopup1 }) => {
  const handleClose = () => setPendingPopup1(false);

  const content = (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: "rgba(15,23,42,0.45)",
        backdropFilter: "blur(3px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1400,
        p: 2,
        animation: "fadeIn .15s ease-out",
      }}
      onClick={handleClose}
    >
      <Paper
        elevation={0}
        onClick={(e) => e.stopPropagation()}
        sx={{
          width: 380,
          maxWidth: "92vw",
          borderRadius: 3,
          p: "28px 24px 20px",
          position: "relative",
          textAlign: "center",
          boxShadow: "0 24px 60px rgba(0,0,0,0.25)",
          animation: "popIn .18s ease-out",
        }}
      >
        {/* Close X */}
        <Box
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            width: 28,
            height: 28,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "#9CA3AF",
            transition: "all .15s",
            "&:hover": { bgcolor: "#F3F4F6", color: "#374151" },
          }}
        >
          <CloseRoundedIcon sx={{ fontSize: 18 }} />
        </Box>

        {/* Icon */}
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: "#FFF7ED",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <HourglassEmptyRoundedIcon sx={{ fontSize: 32, color: "#F97316" }} />
        </Box>

        {/* Title */}
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 700,
            color: "#111827",
            lineHeight: 1.3,
            mb: 0.75,
          }}
        >
          Not Submitted
        </Typography>

        {/* Message */}
        <Typography
          sx={{
            fontSize: 13,
            color: "#6B7280",
            lineHeight: 1.55,
            mb: 3,
          }}
        >
          This student has not submitted the assessment yet. You'll be not able
          to review their answers.
        </Typography>

        {/* Action */}
        <Stack direction="row" justifyContent="center">
          <Button
            onClick={handleClose}
            variant="contained"
            disableElevation
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: 13,
              borderRadius: 2,
              px: 3,
              py: 0.9,
              bgcolor: "#F97316",
              boxShadow: "0 3px 10px rgba(249,115,22,.25)",
              "&:hover": {
                bgcolor: "#EA580C",
                boxShadow: "0 5px 14px rgba(249,115,22,.35)",
              },
            }}
          >
            Got it
          </Button>
        </Stack>
      </Paper>

      {/* Keyframes */}
      <style>
        {`
          @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
          @keyframes popIn {
            from { opacity: 0; transform: translateY(6px) scale(.97) }
            to   { opacity: 1; transform: translateY(0) scale(1) }
          }
        `}
      </style>
    </Box>
  );

  const portalTarget = document.getElementById("modal");
  return portalTarget ? ReactDOM.createPortal(content, portalTarget) : content;
};

export default PendingSpopup;
